import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
interface VotingModalButtonProps {
  readonly drop: ExtendedDrop;
  readonly onClick: () => void;
  readonly variant?: "default" | "subtle"; // Add variant prop for styling flexibility
}
const VotingModalButton: React.FC<VotingModalButtonProps> = t0 => {
  const $ = _c(6);
  const {
    drop,
    onClick,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  if (!canShowVote) {
    return null;
  }
  let t2;
  if ($[0] !== onClick) {
    t2 = e => {
      e.stopPropagation();
      onClick();
    };
    $[0] = onClick;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClick = t2;
  const variantClasses = variant === "subtle" ? "tw-bg-iron-900 tw-border-iron-700 tw-text-iron-200 tw-font-medium hover:tw-text-white hover:tw-bg-primary-600 hover:tw-border-primary-600 hover:tw-shadow-md group" : "tw-bg-primary-500 tw-border-primary-500 tw-text-white tw-font-semibold hover:tw-bg-primary-600 hover:tw-shadow-md";
  const buttonClasses = `${"tw-flex tw-items-center tw-justify-center tw-gap-x-1.5 tw-px-3 tw-py-1.5 tw-rounded-md tw-border tw-border-solid tw-shadow-sm tw-text-xs tw-whitespace-nowrap tw-transition-all tw-duration-150 tw-ease-in-out active:tw-transform active:tw-translate-y-0.5 active:tw-shadow-sm"} ${variantClasses}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>Vote for this!</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== buttonClasses || $[4] !== handleClick) {
    t4 = <button type="button" onClick={handleClick} className={buttonClasses}>{t3}</button>;
    $[3] = buttonClasses;
    $[4] = handleClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default VotingModalButton;